export default __webpack_public_path__ + "static/media/tronlink.56cb635c.png";